/**
 * v36 — **한 줄로 세운다.** 앞 일이 끝나야(이루든 실패하든) 다음 일이 시작한다.
 *
 * Flower 엔진의 생성(`create-receiver.ts` 의 `createFlowerReceiver`)이 이것을 쓴다. 생성은 비동기이고(번들 ·
 * `MEDIA_ATTACHED`) 한 쌍의 `<video>` 는 페이지에 하나다(`playback-buffers.ts`). 생성 도중에 시청 효과가 다시
 * 돌면(채널 전환 · `authToken` 변경) 버려질 생성과 새 생성이 **같은 `<video>` 에 hls.js 를 하나씩** 붙였다 — 뒤의
 * 것이 `src` 를 덮어 앞의 것은 끝내 붙지 못한 채 워커·리스너와 함께 남고, 순서에 따라서는 앞의 정리가 뒤의
 * `src` 를 지운다. 줄을 세우면 앞의 것이 붙고(또는 멈추고) 정리까지 끝난 뒤에 다음이 `<video>` 에 손댄다.
 */
export function serialTurns(): <T>(task: () => Promise<T>) => Promise<T> {
  let tail: Promise<unknown> = Promise.resolve();
  return <T>(task: () => Promise<T>): Promise<T> => {
    const run = tail.then(task);
    // 실패해도 줄은 이어진다 — 거절은 부른 쪽이 `run` 으로 받는다.
    tail = run.then(
      () => undefined,
      () => undefined,
    );
    return run;
  };
}
